
import store from "./store";

export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  winboxBaseUrl: process.env.VUE_APP_BASE_WINBOX_URL,
  multiBaseUrl: process.env.VUE_APP_BASE_MULTI_URL,
  userBaseUrl: "/member",
  userReportUrl: "/report",

  brand: process.env.VUE_APP_BRAND,
  languageOptions: ['en','mn'],
  memberMenuWI: ['deposit','withdraw','transfer','rebate','statement','account','qrcode'],
  memberMenuMU: ['deposit','withdraw','statement','account'],
  slotList: ['LIVE22'],
  casinoLost: [],

  live22Game: process.env.VUE_APP_LIVE22_URL,
  uuslotGame:process.env.VUE_APP_UUSLOT_URL,
  ppsGame:process.env.VUE_APP_PPS_URL,
  ppsGameImgUrl: process.env.VUE_APP_PPS_GAMEIMG_URL,
  ppcGame:process.env.VUE_APP_PPC_URL,
  ybGame: process.env.VUE_APP_YB_URL,
  wbetGame: process.env.VUE_APP_WBET_URL,
  evoGame: process.env.VUE_APP_EVO_URL,
  epicGame: process.env.VUE_APP_EPIC_URL,
  megaGame: process.env.VUE_APP_MEGA_URL,

  lcResultURL: process.env.VUE_APP_LC_RESULT_URL,

  // nekoGame: process.env.VUE_APP_NEKO_URL,
  // wbetWidget: process.env.VUE_APP_WBET_WIDGET,
  // wBetUrl: process.env.VUE_APP_WBET_URL,
  // kingkongGame: process.env.VUE_APP_KINGKONG_URL,
  // pegGame:process.env.VUE_APP_PEG_URL,
  // uuslotGame:process.env.VUE_APP_UUSLOT_URL,
  useConfigUrl: process.env.VUE_APP_STATIC_URL,
  // lgCasino:process.env.VUE_APP_LGCASINO_URL,

  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    
    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }
    
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getLoginUrl() {
    if (this.useConfigUrl == "true") {
      return this.winboxBaseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      if (this.useConfigUrl == "true") {
        return this.winboxBaseUrl;
      } else {
        return "https://api." + domain;
      }     
    } else { 
      return this.winboxBaseUrl;
    }
  },
  getBaseUrl() {    
    var domain = this.getDomain(window.location.hostname, false);
    var accGroup = store.getters.accountGroup;
    var pathname = window.location.pathname;

    if (domain != "localhost") {
      if (this.useConfigUrl == "true") {
        if(accGroup == "WI" || pathname == '/registration' || pathname == '/createplayer1') {
          return this.winboxBaseUrl;
        }  

        if (accGroup == "MU") {
          return this.multiBaseUrl;
        }
      } else {
        if(accGroup == "WI" || pathname == '/registration' || pathname == '/createplayer1') {
          return "https://api." + domain;
        } 

        if (accGroup == "MU") {
          return "https://apimulti." + domain;
        }
      }     
    } else { 
      if(accGroup == "WI" || pathname == '/registration' || pathname == '/createplayer1') {
        return this.winboxBaseUrl;
      } 
      
      if (accGroup == "MU") {
        return this.multiBaseUrl;
      }
    }
  },
  memberLogin() {
    return this.getLoginUrl() + this.userBaseUrl + "/memberlogin";
  },
  getBalance() {
    return this.getBaseUrl() + this.userBaseUrl + "/getbalance";
  },
  updatePassword() {
    return this.getBaseUrl() + this.userBaseUrl + "/updatepassword";
  },
  forgotPassword() {
    return this.getLoginUrl() + this.userBaseUrl + "/forgotpassword";
  },
  addPlayer1() {
    return this.getBaseUrl() + this.userBaseUrl + "/player1add";
    // return this.getBaseUrl() + this.userBaseUrl + "/player1addaftertac";
  },
  getTAC1() {
    return this.getBaseUrl() + this.userBaseUrl + "/player1tacget";
  },
  addMember() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberadd";
    // return this.getBaseUrl() + this.userBaseUrl + "/memberaddaftertac";
  },
  getTAC() {
    return this.getBaseUrl() + this.userBaseUrl + "/membertacget";
  },
  memberTransfer() {
    return this.getBaseUrl() + this.userBaseUrl + "/membertransfer";
  },
  manualDeposit() {
    return this.getBaseUrl() + this.userBaseUrl + "/depositticket";
  },
  addWithdrawTicket() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawticket";
  },
  getMemberRebateWallet() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberrebatewallet";
  },
  getMemberRebateClaim() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberrebateclaim";
  },
  getMemberBankMode() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberbankmode";
  },
  getMemberBankLookup() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberbanklookup";
  },
  getMemberBankList() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberbanklist";
  },
  addMemberBank() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberbankadd";
  },
  addMemberFavGame() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberfavgameadd";
  },
  deleteMemberFavGame() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberfavgamedelete";
  },
  getMemberFavGame() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberfavgamelist";
  },
  getPromo(){
    return this.getBaseUrl() + this.userBaseUrl + "/getpromolist";
  },
  dailyStatement() {
    return this.getBaseUrl() + this.userReportUrl + "/getdailystatement";
  },
  memberTicketList() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlist";
  },
  memberTransferList() {
    return this.getBaseUrl() + this.userBaseUrl + "/membertransferlog";
  },
  dailyWinloseProvider() {
    return this.getBaseUrl() + this.userReportUrl + "/getdailywinlosebyprovider";
  },
  getGameResultLivecasino() {
    return this.getBaseUrl() + this.userReportUrl + "/gameresultlivecasino";
  },
  getGameResultSlot() {
    return this.getBaseUrl() + this.userReportUrl + "/gameresultslot";
  },
  getGameResultSports() {
    return this.getBaseUrl() + this.userReportUrl + "/gameresultsports";
  },
  getLive22GameList(){
    return this.live22Game + "/getgamelist?lang=en"
  },
  getLive22FishGameList(){
    return this.live22Game + "/getfishgamelist?lang=en"
  },
  launchLive22(){
    return this.live22Game + "/launchgame"
  },
  getLive22Result(){
    return this.live22Game + "/getbetdetail"
  },
  getUuslotGameList(){
    return this.uuslotGame + "/getgamelist?lang=en"
  },
  launchUuslot(){
    return this.uuslotGame + "/launchgame"
  },
  getUuResult(){
    return this.uuslotGame + "/getbetdetail"
  },
  getPPSGameList(){
    return this.ppsGame + "/getgamelist"
  },
  launchPPS(){
    return this.ppsGame + "/launchgame"
  },
  getPPSResult(){
    return this.ppsGame + "/getbetdetail"
  },
  launchPPC(){
    return this.ppcGame + "/launchgame"
  },
  getPPCResult(){
    return this.ppcGame + "/getbetdetail"
  },
  launchYB(){
    return this.ybGame + "/launchgame"
  },
  launchWB(){
    return this.wbetGame + "/launchgame"
  },
  launchEVO(){
    return this.evoGame + "/launchgame"
  },
  getEVOResult(){
    return this.evoGame + "/getbetdetail"
  },
  getEpicGameList(){
    return this.epicGame + "/getgamelist?lang=en"
  },
  launchEpic(){
    return this.epicGame + "/launchgame"
  },
  getEpicResult(){
    return this.epicGame + "/getbetdetail"
  },
  getMegaGameList(){
    return this.megaGame + "/getgamelist?lang=en"
  },
  launchMega(){
    return this.megaGame + "/launchgame"
  },
  getMegaResult(){
    return this.megaGame + "/getbetdetail"
  },
};
